/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { Component, Inject } from '@angular/core';
import { Router, RouteReuseStrategy } from '@angular/router';
import { NB_AUTH_OPTIONS } from '@nebular/auth/auth.options';
import { getDeepFromObject } from '@nebular/auth/helpers';
import { ToasterConfig, ToasterService } from 'angular2-toaster';
import { NbAuthService } from '@nebular/auth/services/auth.service';
import { NbAuthResult } from '@nebular/auth/services/auth-result';
import { NegocioDataService } from '../../../../services/negocio-data.service';
import { User } from '../../../../shared/user';
import { environment } from '../../../../../environments/environment';
import { CustomReuseStrategy } from '../../../../shared/router/custom-reuse-strategy';
import Utils from '../../../../shared/utils';

const LOGN = environment.login;
const PSWD = environment.password;

@Component({
  selector: 'nb-request-password-page',
  styleUrls: ['./request-password.component.scss'],
  template: `
    <nb-auth-block>

      <h2 class="title">Recupere sua senha</h2>
      <small class="form-text sub-title">Insira o e-mail cadastrado</small>
      <form (ngSubmit)="requestPass()" #requestPassForm="ngForm">
        <div *ngIf="showMessages.error && errors && errors.length > 0 && !submitted"
             class="alert alert-danger" role="alert">
          <div><strong>Algo deu errado!</strong></div>
          <div *ngFor="let error of errors">{{ error }}</div>
        </div>
        <div *ngIf="showMessages.success && messages && messages.length > 0 && !submitted"
             class="alert alert-success" role="alert">
          <div><strong>Hooray!</strong></div>
          <div *ngFor="let message of messages">{{ message }}</div>
        </div>

        <div class="form-group">
          <label for="input-email" class="sr-only">Enter your email address</label>
          <input name="email" [(ngModel)]="user.email" id="input-email" #email="ngModel"
                 class="form-control" placeholder="Email address" pattern=".+@.+\..+"
                 [class.form-control-danger]="email.invalid && email.touched"
                 [required]="getConfigValue('forms.validation.email.required')"
                 autofocus>
          <small class="form-text error" *ngIf="email.invalid && email.touched && email.errors?.required">
            Email necessário!
          </small>
          <small class="form-text error"
                 *ngIf="email.invalid && email.touched && email.errors?.pattern">
          O Email precisa ser válido!
          </small>
        </div>

        <button [disabled]="submitted || !requestPassForm.form.valid" class="btn btn-hero-success btn-block"
                [class.btn-pulse]="submitted">
          Enviar
        </button>
      </form>

      <div class="links col-sm-12">
        <small class="form-text">
          <a routerLink="../login"><strong>Voltar para página de Login</strong></a>
        </small>
      </div>
    </nb-auth-block>
  `,
})
export class NbRequestPasswordComponent {

  redirectDelay: number = 0;
  showMessages: any = {};
  provider: string = '';

  submitted = false;
  errors: string[] = [];
  messages: string[] = [];
  username: string;
  userToken: any = {};

  configT: ToasterConfig;
  successType = 'success';
  warningType = 'warning';
  errorType = 'error';
  infoType = 'info';

  user: User = new User ({
    id: '',
    username: '',
    password: '',
    active: 'false',
    document: '',
    name: '',
    firstName: '',
    middleName: '',
    lastName: '',
    birthDate: '',
    email: '',
    created_date: '',
    changed_date: '',
    employeeLog_id: '',
    changePassword: '',
    msg: '',
    responsibleAnalyst: '',
    id_employeeType: '',
    requestPassword: ''
  });

  constructor(protected service: NbAuthService,
              @Inject(NB_AUTH_OPTIONS) protected config = {},
              protected router: Router,
              private negocioDataService: NegocioDataService,
              private routeReuse: RouteReuseStrategy) {

    this.redirectDelay = this.getConfigValue('forms.requestPassword.redirectDelay');
    this.showMessages = this.getConfigValue('forms.requestPassword.showMessages');
    this.provider = this.getConfigValue('forms.requestPassword.provider');
  }

  requestPass(): void {
    this.errors = this.messages = [];
    this.submitted = true;

    // this.loggedEmployee()

    const result = this.negocioDataService.getRequestSenha(this.user.email);

    if (result) {
      result.subscribe(dados => {
        //this.logout();

        if (dados.msg == "OK"){
          alert('Sucesso. Favor verificar o seu e-mal para os próximos passos da alteração da sua senha.');
          // Utils.showToast(this.configT, this.successType, "Sucesso", "Favor verificar o seu e-mal para os próximos passos da alteração da sua senha.", this.toasterService);
          this.router.navigate(['auth/login']);
        } else {
          alert('Erro ao tentar atualizar a senha. ' + dados.msg);
          // Utils.showToast(this.configT, this.errorType, "Erro", "Erro ao tentar atualizar a senha. " + dados.msg, this.toasterService);
        }
        });
    }
  }

  getConfigValue(key: string): any {
    return getDeepFromObject(this.config, key, null);
  }

  loggedEmployee() {
    this.userToken.email = LOGN;
    this.userToken.password = PSWD;

    this.service.authenticate(this.provider, this.userToken).subscribe((result: NbAuthResult) => {

       if (result.isSuccess()) {
         this.messages = result.getMessages();

       } else {
         this.errors = result.getErrors();
       }
    });
  }

  logout(): void {
    this.service.logout(this.provider).subscribe((result: NbAuthResult) => {
      (<CustomReuseStrategy>this.routeReuse).clearHandlers();
      const redirect = result.getRedirect();
      if (redirect) {
        setTimeout(() => {
        }, this.redirectDelay);
      }
    });
  }
}
